import axios from "axios"
import cookie from 'react-cookies'
/*import Qs from 'qs'*/
/*axios.defaults.headers.post['Content-Type']= 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.withCredentials = false;*/
axios.interceptors.response.use(result=>{
   return result.data
});
/*axios.defaults.transformRequest=(data={})=>{
return Qs.stringify(data)
 };*/
axios.interceptors.request.use(
   config=>{
      const token =cookie.load('vlec_token')
    
      // config.data=JSON.stringify(config.data);
        config.headers={
          //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          'Authorization':token
    }
      return config
     }
)
export default axios



// WEBPACK FOOTER //
// ./src/api/index.js